export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Проверка на iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return DEVICE_TYPE.iOS;
  }

  // Проверка на Android
  if (/android/i.test(userAgent)) {
    return DEVICE_TYPE.Android;
  }

  return DEVICE_TYPE.unknown;
};

export const DEVICE_TYPE = {
  iOS: 'iOS',
  Android: 'Android',
  unknown: 'unknown'
}
